/* Display the approved branding edit of one kit photo without changing review records. */
(() => {
  'use strict';

  const script = document.currentScript;
  const replacement = script && script.getAttribute('data-ffs-review-photo');
  if (!replacement) return;

  const originalPath = '/images/I/71CU+zXChGL._SY1000.jpg';
  const attributes = ['src', 'srcset', 'href', 'data-src', 'data-srcset', 'data-mfp-src'];
  const selector = attributes.map((name) => `[${name}]`).join(',');

  function isOriginal(value) {
    if (!value) return false;
    try {
      const url = new URL(value, document.baseURI);
      return (url.protocol === 'https:' || url.protocol === 'http:') &&
        url.hostname === 'm.media-amazon.com' &&
        decodeURIComponent(url.pathname) === originalPath;
    } catch (_) {
      return false;
    }
  }

  function imageValue(value, name) {
    if (name === 'srcset' || name === 'data-srcset') {
      return value.split(',').map((candidate) => candidate.replace(
        /^(\s*)(\S+)/,
        (match, spacing, url) => isOriginal(url) ? spacing + replacement : match
      )).join(',');
    }
    return isOriginal(value) ? replacement : value;
  }

  function patchElement(element) {
    for (const name of attributes) {
      const before = element.getAttribute(name);
      if (before === null) continue;
      const after = imageValue(before, name);
      if (after !== before) element.setAttribute(name, after);
    }
  }

  function scan(root) {
    if (root.nodeType === 1) patchElement(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(patchElement);
  }

  // Modals live outside the review widget; watch image attributes on the page
  // but match only this exact Amazon photo. Review JSON and text are untouched.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        patchElement(mutation.target);
      } else {
        mutation.addedNodes.forEach(scan);
      }
    }
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: attributes,
  });
  scan(document);

  // Also cover replacement widgets after sorting, pagination, or app reloads.
  document.addEventListener('jdgm.widgetLoaded', () => scan(document));
  document.addEventListener('jdgm.doneLoadingWidget', () => scan(document));
})();
